import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Table as CommonTable } from '../../../../../common/table'
import {
  getNoDataComponent,
  handleIconDownload,
  renderTd,
  sortKeySchemaTable,
} from '../../helper'
import classes from '../../index.module.scss'
import { TABLE_ROW_IDS } from './constant'
import {
  selectByIdTable,
  selectCell,
  selectIdTable,
  selectIndicatorById,
  selectYears,
} from './store/slice'

const Table = ({ isDynamicReport, id, checkTable }) => {
  let ids = useSelector(selectIdTable)
  const years = useSelector(selectYears)

  const tableSchema = {
    UNIT: 'unit',
    RATIO_NAME: 'ratioName',
  }
  years.forEach((year) => (tableSchema[String(year)] = String(year)))

  if (isDynamicReport) {
    ids = ids.filter((id) => checkTable.includes(id))
  }

  const rowIds = ids.filter((id) => TABLE_ROW_IDS.includes(id))

  const isNoData = !years.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <div className={`${classes.tablePanelContainerFixOverflow} flex1 minH0`}>
      <CommonTable
        ids={rowIds}
        isDisplayScroll={!isDynamicReport}
        isNoStickyHead={isDynamicReport}
        getDataFromRedux={selectCell}
        schema={sortKeySchemaTable(Object.keys(tableSchema)).map((key) => {
          const title = `financialAnalysis.${key}`
          const colId = tableSchema[key]
          const isYearColumn = !['ratioName', 'unit'].includes(colId)
          return {
            colId,
            title,
            isI18n: true,
            thStyle: {
              marginLeft: !isYearColumn ? '' : 'auto',
              justifyContent: isYearColumn ? 'flex-end' : 'flex-start',
            },
            tdStyle: {
              textAlign: !isYearColumn ? 'left' : 'right',
              whiteSpace: !['ratioName'].includes(colId) ? 'nowrap' : '',
            },
            render: renderTd(selectByIdTable, selectIndicatorById),
          }
        })}
        autoHeightMax={300}
      />
    </div>
  )
}

export default Table
